import React from "react";
import { ShieldOff } from "lucide-react";
import usePermissions from "@/lib/usePermissions";

/** Phase 84.44 — route-level enforcement for the founder-only Access
 * Management overhaul. Wraps a whole page/hub; renders "Access denied"
 * instead of the page when the resolved `feature` (or any of `anyFeature`)
 * is off for the current user. Direct-URL navigation is blocked here, not
 * just hidden from the sidebar. */
export default function FeatureGate({ feature, anyFeature, label, children }) {
  const can = usePermissions();
  const allowed = feature ? can(feature) : (anyFeature || []).some((f) => can(f));
  if (allowed) return children;
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="page-access-denied">
      <div className="text-center max-w-sm">
        <div className="w-14 h-14 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
          <ShieldOff size={22} className="text-red-500" />
        </div>
        <div className="text-lg font-semibold text-slate-800 mb-1">Access denied</div>
        <p className="text-sm text-slate-500">
          You don&rsquo;t have permission to view {label || "this page"}. Ask a Founder to grant it from Access Management.
        </p>
      </div>
    </div>
  );
}
